<template>
  <slot name="title" :account-info="accountInfo"></slot>
  <div class="card card-white">
    <!--
      Getting a warning here that @account-info does not exist as an event whoever knows more about this part of the product
      please update this
    -->
    <PaymentRequestList @account-info="updateAccountInfo" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import PaymentRequestList from '@/components/RequestPaymentDashboard/PaymentRequestsList.vue'

export default defineComponent({
  name: 'PaymentRequestTable',
  components: {
    PaymentRequestList,
  },
  data() {
    return {
      accountInfo: null,
    }
  },
  methods: {
    updateAccountInfo(data) {
      this.accountInfo = data
    },
  },
})
</script>
